var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOthersettings = function SvgOthersettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 1 8 4.5v9L10 19l-8-4.5v-9L10 1Zm0 1.89L3.684 6.444v7.114L10 17.109l6.316-3.552V6.443L10 2.891Zm0 10.383c-1.86 0-3.368-1.466-3.368-3.273 0-1.807 1.508-3.273 3.368-3.273 1.86 0 3.368 1.466 3.368 3.273 0 1.807-1.508 3.273-3.368 3.273Zm0-1.637c.93 0 1.684-.732 1.684-1.636 0-.904-.754-1.636-1.684-1.636-.93 0-1.684.732-1.684 1.636 0 .904.754 1.636 1.684 1.636Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
};
export default SvgOthersettings;